import React, { useState } from 'react';
import supabase from '../supabase/supabase';

export default function AdminCategoryForm({ onCategoryAdded }) {
  const [name, setName] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg('');
    setLoading(true);

    const { error } = await supabase.from('categories_1715000000').insert([{ name }]);
    
    if (error) {
      setMsg(`Error: ${error.message}`);
    } else {
      setMsg('Category added successfully!');
      setName('');
      if (onCategoryAdded) onCategoryAdded();
    }
    setLoading(false);
  };

  return (
    <div className="bg-white p-8 rounded-3xl shadow-retro border-4 border-retro-brown">
      <h2 className="font-display text-2xl tracking-wider text-retro-brown uppercase mb-6 drop-shadow-[1px_1px_0_#C3D730]">Add Category</h2>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <div>
          <label className="block text-lg font-bold text-retro-brown mb-2">Name</label>
          <input 
            type="text" 
            placeholder="e.g. Real Estate" 
            value={name} 
            onChange={(e) => setName(e.target.value)} 
            className="w-full p-4 border-4 border-retro-brown rounded-xl focus:outline-none focus:ring-4 focus:ring-retro-blue font-bold text-retro-brown shadow-[inset_0_2px_4px_rgba(0,0,0,0.1)]"
            required 
          />
        </div>
        <button 
          type="submit" 
          disabled={loading} 
          className="bg-retro-yellow text-retro-brown py-4 rounded-xl font-display text-xl tracking-wider border-4 border-retro-brown shadow-retro hover:shadow-retro-hover hover:-translate-y-1 active:translate-y-1 active:shadow-retro-active transition-all mt-2 disabled:opacity-50"
        >
          {loading ? 'ADDING...' : 'CREATE'}
        </button>
        {msg && (
          <p className={`text-base font-bold mt-2 p-3 border-2 border-retro-brown rounded-xl ${msg.includes('Error') ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>
            {msg}
          </p>
        )}
      </form>
    </div>
  );
}